import apiClient from './client';

export interface User {
  id: string;
  vkId: number;
  email?: string;
  firstName: string;
  lastName: string;
  avatar?: string;
  role: string;
}

export interface VKIDAuthResponse {
  access_token: string;
  user: User;
}

export const authApi = {
  getMe: async (): Promise<User> => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    window.location.href = '/';
  },

  loginWithVKID: async (payload: { token: string; uuid: string }): Promise<VKIDAuthResponse> => {
    const response = await apiClient.post('/auth/vkid', payload);
    return response.data;
  },

  // Оставляем старый метод для совместимости (будет удален позже)
  loginWithVK: () => {
    window.location.href = `${apiClient.defaults.baseURL}/auth/vk`;
  },
};
